import { Component, ElementRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import * as jQuery from 'jquery';
import { ModalService } from './modal.service';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-modal',
	styleUrls: ['./modal.component.less'],
	templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit, OnDestroy {
	@Input() id: string;
	@Input() closeOnBackground = true;
	private element: any;

	constructor(private modalService: ModalService, private el: ElementRef) {
		this.element = jQuery(el.nativeElement);
	}

	ngOnInit(): void {
		// tslint:disable-next-line: no-this-assignment
		const modal = this;

		// ensure id attribute exists
		if (!this.id) {
			console.error('modal must have an id');
			return;
		}

		// move element to bottom of page (just before </body>) so it can be displayed above everything else
		this.element.appendTo('body');

		// close modal on background click
		this.element.on('click', (e: any) => {
			const target = jQuery(e.target);
			if (this.closeOnBackground) {
				if (!target.closest('.modal-body').length) {
					modal.close();
				}
			}
		});

		// add self (this modal instance) to the modal service so it's accessible from controllers
		this.modalService.add(this);
	}

	// remove self from modal service when directive is destroyed
	ngOnDestroy(): void {
		this.modalService.remove(this.id);
		this.element.remove();
	}

	// open modal
	open(): void {
		this.element.show();
		jQuery('body').addClass('modal-open');
	}

	// close modal
	close(): void {
		this.element.hide();
		jQuery('body').removeClass('modal-open');
	}
}
